import axios from "axios";

export default {
    get(data) {
        const API = `/api/payment/CardType`;

        return new Promise((resolve, reject) => {
            axios.post(API, { bin: data }).then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};